export const BUILD_VERSION = '1787197541';
